<template>
	<BaseButton
		:classes="buttonClasses"
		:disabled="props.disabled || !thirdPartyAuthStore.isGoogleLibraryLoaded"
		:is-working="props.isWorking"
		data-test="google-auth-button"
		@click="handleClick"
		><BaseSvgIcon v-if="!props.isWorking" class="mr-50" name="logo-google-g" height="24" width="24" />Continue with
		Google</BaseButton
	>
</template>

<script lang="ts">
export default {
	name: 'GoogleAuthButton'
};
</script>

<script setup lang="ts">
import { GoogleAuthParameters, ThirdPartyAuthTheme } from 'types/third-party-auth';
import { computed } from 'vue';
import { useThirdPartyAuthStore } from '@stores/third-party-auth';

interface Props {
	disabled?: boolean;
	isWorking?: boolean;
	theme?: ThirdPartyAuthTheme;
}

interface Emits {
	(e: 'google-auth-payload', value: GoogleAuthParameters): void;
}

const props = withDefaults(defineProps<Props>(), {
	disabled: false,
	isWorking: false,
	theme: 'PRIMARY'
});

const emits = defineEmits<Emits>();

const thirdPartyAuthStore = useThirdPartyAuthStore();

const buttonClasses = computed((): string => {
	return `button ${props.theme === 'PRIMARY' || props.theme === 'TERTIARY' ? 'button-default-third-party-auth-reversed' : 'button-default-third-party-auth'} no-wrap width-100`;
});

function handleClick(): void {
	const client = window.google.accounts.oauth2.initCodeClient({
		client_id: import.meta.env.VITE_GOOGLE_SIGN_UP_ID,
		scope: 'openid email profile',
		ux_mode: 'popup',
		callback: (response: { code: string }) => {
			if (response.code) {
				const payload = {
					authCode: response.code,
					redirectUri: import.meta.env.VITE_BASE_URL,
					googleClientId: import.meta.env.VITE_GOOGLE_SIGN_UP_ID,
					fundriseClientId: import.meta.env.VITE_API_CLIENT_ID
				};

				emits('google-auth-payload', payload);
			}
		}
	});

	client.requestCode();
}
</script>
